import Controller from "@ember/controller";

export default class GroupMessagesController extends Controller {}
